import {
    createBrowserRouter,
    createRoutesFromElements,
    Route
} from "react-router-dom";
import Frontend from "./components/Frontend";
import Body, { loader as BodyLoader } from "./components/Frontend/Body";
import HealthCheck from "./components/HealthCheck";

// See https://reactrouter.com/en/main/start/concepts#index-routes for index route. This route is required in order to
// support behavior if user visits the root URL.
const router = createBrowserRouter(
    createRoutesFromElements(
        <>
            <Route path="/hc/:file" element={ <HealthCheck /> } />
            <Route path="/" element={<Frontend />} >
                <Route index={true} element={<Body />} loader={ BodyLoader }/>
                <Route path="*" element={<Body />} loader={ BodyLoader }/>
            </Route>
        </>
    )
);

export default router;